import { Component, createSignal } from "solid-js";

import TypeConnectModal from "../modais/TypeConnectModal";
import ConnectModal from "../modais/ConnectModal";
import ServerConfigurationModal from "../modais/ServerConfigurationModal";
import SuccessfulModal from "../modais/SuccessfulModal";

interface ElearningFlowProps {
  show: boolean;
  onClose: () => void;
  onFinish?: () => void;
}

const ElearningFlow: Component<ElearningFlowProps> = (props) => {
  const [step, setStep] = createSignal(1);
  const [isSubdomain, setIsSubdomain] = createSignal(false);

  const handleNext = () => {
    if (step() <= 4) {
      setStep(step() + 1);
    } else {
      props.onFinish?.();
    }
  };

  const handleBack = () => {
    if (step() > 1) {
      setStep(step() - 1);
    }
  };

  const handleClose = () => {
    setStep(1);
    props.onClose();
  };

  const handleFinish = () => {
    setStep(1);
    props.onFinish?.();
  };

  const handleSelectType = (type: string) => {
    console.log("Selected type:", type);
    setIsSubdomain(type === "subdomain");
    handleNext();
  };

  const handleSelect = (connections: string) => {
    console.log("Connections:", connections);
    handleNext();
  };

  const handleVerify = () => {
    console.log("Verification process started");
    handleNext();
  };

  return (
    <>
      {step() === 1 && (
        <TypeConnectModal
          show={props.show}
          onClose={handleClose}
          onSelect={handleSelectType}
        />
      )}
      {step() === 2 && (
        <ConnectModal
          show={props.show}
          onClose={handleClose}
          onSelect={handleSelect}
          hasWebsite
          hasDomain
          hasConnectionType
          isSubdomain={isSubdomain()}
        />
      )}
      {step() === 3 && (
        <ServerConfigurationModal
          show={props.show}
          onClose={handleClose}
          onVerify={handleVerify}
        />
      )}
      {step() === 4 && (
        <SuccessfulModal
          show={props.show}
          onClose={handleClose}
          onFinish={handleFinish}
        />
      )}
    </>
  );
};

export default ElearningFlow;
